import { Injectable } from '@angular/core';

import {  HttpGeneralService, OutpatientParms} from '../../../../shared';
import { RegPatService } from '../../../../pricing/reg-pat-service/reg-pat-service';

import { CONFIG } from '../../../../shared/config';
import { ScheduleMaster } from '../../../scheduleing/schedule.service';
import { CallData, TotalData } from '../../../../call-center/call-center-reservation';

let reservationVisitUrl = CONFIG.baseUrls.reservationVisit;
let callCenterReservation = CONFIG.baseUrls.emergencyReservation;
let schedulingUrl = CONFIG.baseUrls.scheduling;

@Injectable()
export class ModifyAppointmentService {
    constructor(
        private _httpGeneralService: HttpGeneralService) { }

    EditDoctorAndTime(selectedService: RegPatService[]) {
        return this._httpGeneralService.add( selectedService, `${reservationVisitUrl}/ModifyAppointment`);
    }

    ApplogiezeAndShedualNewAppointment(selectedService: RegPatService[]) {
      return this._httpGeneralService.add( selectedService, `${reservationVisitUrl}/ApplogiezeAndShedualNewAppointment`);
  }



    getResourceSchedulingList(resourceData: ScheduleMaster) { 
        return this._httpGeneralService.add(resourceData , `${schedulingUrl}/GetResourceSchedules`)
      }

      
      updatePatientAppointment(patient: TotalData) {
    return this._httpGeneralService.add<TotalData>(patient, `${callCenterReservation}/updatePatientAppointment`);
  }


}

